import { createFileRoute } from '@tanstack/react-router'

import { PartnerShowSkeleton } from '@/features/partners/components/PartnerShowSkeleton'
import { humanName } from '@/features/partners/config'
import { resolvePartnerShowIdentifier } from '@/features/partners/lib/partnerRoute'
import { DigitalProductPartnersShow } from '@/features/partners/Show'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'
import { useGamificationDataStore } from '@/shared/store/gamificationDataStore'
import { PageHeader, Screen } from '@/shared/ui/Layout'

export const Route = createFileRoute('/_event/parceiros/$partnerId')({
  component: DigitalProductPartnersShowPage
})

function DigitalProductPartnersShowPage() {
  const digitalProductId = useRouteDigitalProductId()
  const { partnerId } = Route.useParams()
  const { partners } = useGamificationDataStore(state =>
    state.getActiveProductData()
  )

  // O param aceita id, uid ou slug; o show da API resolve por slug. Enquanto o
  // bundle não chega, um id numérico ainda não tem tradução — segurar o render
  // evita uma requisição que responderia 404.
  const identifier = resolvePartnerShowIdentifier(partners, partnerId)

  if (!identifier) {
    return (
      <Screen className="min-h-0 flex-1 overflow-hidden">
        <Screen.Context>
          <PageHeader title={humanName.singular} backHref="/parceiros" />
        </Screen.Context>
        <Screen.Content className="pb-6 pt-1">
          <PartnerShowSkeleton />
        </Screen.Content>
      </Screen>
    )
  }

  return (
    <DigitalProductPartnersShow
      digitalProductId={digitalProductId}
      id={identifier}
    />
  )
}
